<template>
	<div class="main-container">
		<!-- Navbar section -->
		<HeaderAgency />
    <AboutUsHome class="aboutPage"/>
    

    <!-- footer section -->
    <FooterMain />

		<!-- overlay menu section -->
		<OverlayMenu/>
  </div>
</template>

<script>
  import HeaderAgency from "../../components/HeaderAgency.vue";
  import FooterMain from "../../components/FooterMain";
	import OverlayMenu from "../../components/OverlayMenu";
	import AboutUsHome from "../../components/sections/AboutUsHome";
  export default {
    name: 'FaqDetails',
    components: {
      HeaderAgency,
      FooterMain,
      OverlayMenu,
      AboutUsHome
    },
    data (){
          return {
            items: [
              {
                  heading:'Is PlusMinus free?', 
                  text:'PlusMinus is free to download and free to use. We allow users to simply be on the platform at no charge. We are right now focusing entirely on creating value for our end users and this means a holistic solution which covers the App, Community and Blog in one.'
              },
              {
                  heading:'Will PlusMinus sell my data?', 
                  text:'PlusMinus is free to download and free to use. We allow users to simply be on the platform at no charge. We are right now focusing entirely on creating value for our end users and this means a holistic solution which covers the App, Community and Blog in one.'
              },
              {
                  heading:'Why are my recent transactions missing?', 
                  text:"Don't worry, it could be because you have not refreshed your data! The PlusMinus App operates on one-time, read-only access and assists you in downloading your transactions to and compiling your transactions on your mobile device. This means that your login credentials are NOT stored by PlusMinus at any point in time and a new One-Time Password will be sent to you when you want to refresh your data for security reasons. We will be working with the banks towards a real-time sync to create a more seamless process."
              },
              {
                  heading:'Why are my transactions in the wrong categories?', 
                  text:'Our PlusMinus categorisation engine is improving everyday to identify the nuances in the transaction names and accurately determine the categories they belong to. In the meantime, you will be able to re-categorise the transactions by simply clicking on them in the transactions page. We aim to make it accurate for our users as it is in line with our belief on how personal finance management should be.'
              },
              {
                  heading:'How can I protect my PlusMinus account?', 
                  text:"Keep your passwords safe. Don't share it with anyone. Mix it up. Include numbers and capital letters in your password to make it stronger. Don't install programs from people or companies you don’t know. Learn what you can do to help prevent identity theft and identify phishing attempts."
              },
              { 
                  heading:'When is the blog and community going to be launched?', 
                  text:'Thank you for your interest! We are a small team now and are working round the clock to bring you the best PlusMinus experience there can be. Stay tuned!'
              },
              { 
                  heading:'How do I close my PlusMinus Account?', 
                  text:'First, login to your PlusMinus account. Send us a contact request from within the app and our representative will contact you regarding the steps to delete your account including all your data.'
              },
              { 
                  heading:'I have more questions, how can I contact you?', 
                  text:'Reach out to us at support@plusminius.my anytime and we will get back to you very soon. We welcome all questions and suggestions, especially good budget tips. 🙂'
              },
            ]
          }
        }
  };
</script> 

<style>
.aboutPage {
  padding-top: 100px;
  background: #E5E5E5 url("../../assets/img/about/about-coin.png");
  background-size: contain;
  background-repeat: no-repeat;
}
.aboutPage .aboutus-inner {
  background-image: none;
}


.faq-main-title h1 {
  font-family: Nunito Sans;
  font-style: normal;
  font-weight: 900;
  font-size: 55px;
  line-height: 80px; 
  display: flex;
  align-items: center;
  letter-spacing: -0.02em;
  color: #214F4D;
}
.faq-main-title p {
  font-family: Nunito Sans;
  font-style: normal;
  font-weight: normal;
  font-size: 24px;
  line-height: 33px;
  align-items: center;
  letter-spacing: -0.02em;
  color: #214F4D;
}
.accordion-faq > .card {
    margin-bottom: 20px;
    border-radius: 20px;
    overflow: hidden;
}
.faq-wreapper {
    background: #E5E5E5 url("../../assets/img/about/about-coin.png");
    padding: 138px 0 50px;
    background-size: contain;
    background-repeat: no-repeat;
}
.faq-section {
  max-width: 1250px;
}
.accordion-header {
  padding: 0;
  border-bottom: 0px solid transparent;
}
.faq-title {
  color: #214F4D;
  background: #fff;
  font-weight: bold;
  font-size: 24px;
  line-height: 33px;
  letter-spacing: -0.02em;
  width: 100%;
  text-align: left;    
  padding: 27px 40px;
  height: inherit;
  position: relative;
}
.faq-title:before {
  position: absolute;
  content: "";
  background: url("../../assets/img/darrow.svg");
  width: 18px;
  height: 12px;
  background-size: contain;
  background-repeat: no-repeat;
  top: 35px;
  right: 36px;
  transition: all ease-in-out 0.5s;
}
.faq-title.not-collapsed:before {
  transform: rotate(180deg);
  transition: all ease-in-out 0.5s;
}
.accordion-faq .card-body {
  padding: 0 40px;
}
 
.card-text {
  font-weight: normal;
  font-size: 18px;
  line-height: 25px;
  color: #214F4D;
  padding-bottom: 32px;
}
 
  @media screen and (max-width: 767px) {
    .faq-wreapper { 
      background-image: url("../../assets/img/bg/faq-bg.png");
      padding: 60px 0 50px;
    }
    .faq-main-title p{
      padding-bottom: 18px;;
    }
    .faq-title { 
      font-size: 18px;
      line-height: 25px;
    }
  }
</style>